import {
  PAGE_ID_CLASSIFY,
  PAGE_ID_WRITE,
  PAGE_ID_MANAGE,
  PAGE_ID_SUCCESS,
  PAGE_ID_SELECT_AD_TYPE,
  PAGE_ID_CONCIERGE,
  PAGE_ID_GUARANTEED_HIRE,
  PAGE_ID_MULTI_LOCATION,
  PAGE_ID_PREMIUM_PLUS,
  PAGE_ID_PAY_AND_POST_V2,
} from 'src/app/shared/constants/pageUid';
import type { Cart } from 'src/graphql/generated';
import type { FormData } from 'src/types/appState';

import isClassifyPageCompleted from '../isClassifyPageCompleted';
import { isSelectAdPageCompleted } from '../isSelectAdPageCompleted';
import {
  isWritePageStarted,
  isWritePageCompleted,
} from '../isWritePageCompleted';

export const getLastValidPage = (
  formData?: FormData,
  currentPageId?: string,
  isEditDraft?: boolean,
  isCopyJob?: boolean,
  cart?: Cart,
) => {
  if (isEditDraft || isCopyJob) {
    return PAGE_ID_CLASSIFY;
  }

  if (
    !isClassifyPageCompleted(formData) ||
    currentPageId === PAGE_ID_CLASSIFY
  ) {
    return PAGE_ID_CLASSIFY;
  }

  if (!isSelectAdPageCompleted(formData, cart) && !currentPageId) {
    return PAGE_ID_CLASSIFY;
  }

  if (
    !isSelectAdPageCompleted(formData) ||
    currentPageId === PAGE_ID_SELECT_AD_TYPE
  ) {
    return PAGE_ID_SELECT_AD_TYPE;
  }

  if (!isWritePageStarted(formData) && !currentPageId) {
    return PAGE_ID_SELECT_AD_TYPE;
  }

  if (!isWritePageCompleted(formData)) {
    return PAGE_ID_WRITE;
  }

  if (
    currentPageId === PAGE_ID_CONCIERGE ||
    currentPageId === PAGE_ID_GUARANTEED_HIRE ||
    currentPageId === PAGE_ID_PREMIUM_PLUS
  ) {
    return PAGE_ID_SELECT_AD_TYPE;
  }

  switch (currentPageId) {
    case PAGE_ID_MULTI_LOCATION:
    case PAGE_ID_WRITE:
    case PAGE_ID_MANAGE:
    case PAGE_ID_PAY_AND_POST_V2:
    case PAGE_ID_SELECT_AD_TYPE:
    case PAGE_ID_SUCCESS:
      return currentPageId;
    default:
      return PAGE_ID_CLASSIFY;
  }
};
